import { ReactNode } from 'react';
import { ControlPosition, DraggableEvent } from 'react-draggable';

import { noop } from '@utils';
import { PubSubService } from '../_shared/pubSubServiceInterface';

class UIDialogService extends PubSubService {
	public static readonly EVENTS = {};

	public static REGISTRATION = {
		name: 'uiDialogService',
		altName: 'UIDialogService',
		create: () => {
			return new UIDialogService();
		}
	};

	serviceImplementation = {
		_dismiss: (_p0: { id: string }) => console.warn('dismiss() NOT IMPLEMENTED'),
		_dismissAll: () => console.warn('dismissAll() NOT IMPLEMENTED'),
		_create: (_p0: {
			id: string;
			content: ReactNode;
			contentProps: object;
			onStart: (_event: DraggableEvent) => void;
			onDrag: (_event: DraggableEvent) => void;
			onStop: (_event: DraggableEvent) => void;
			centralize: boolean;
			preservePosition: boolean;
			preventCutOf: boolean;
			isDraggable: boolean;
			showOverlay: boolean;
			defaultPosition: ControlPosition;
			event?: EventTarget;
			onClickOutside: () => void;
		}) => console.warn('create() NOT IMPLEMENTED')
	};

	constructor() {
		super(UIDialogService.EVENTS);
		this.serviceImplementation = {
			...this.serviceImplementation
		};
	}

	public create({
		id,
		content,
		contentProps,
		onStart = noop,
		onDrag = noop,
		onStop = noop,
		centralize = false,
		preservePosition = true,
		preventCutOf = false,
		isDraggable = true,
		showOverlay = false,
		defaultPosition = undefined,
		event = undefined,
		onClickOutside = noop
	}) {
		return this.serviceImplementation._create({
			id,
			content,
			contentProps,
			onStart,
			onDrag,
			onStop,
			centralize,
			preservePosition,
			preventCutOf,
			isDraggable,
			showOverlay,
			defaultPosition,
			event,
			onClickOutside
		});
	}

	public dismiss({ id }) {
		return this.serviceImplementation._dismiss({ id });
	}

	public dismissAll() {
		return this.serviceImplementation._dismissAll();
	}

	public setServiceImplementation({
		dismiss: dismissImplementation,
		dismissAll: dismissAllImplementation,
		create: createImplementation
	}) {
		if (dismissImplementation) {
			this.serviceImplementation._dismiss = dismissImplementation;
		}
		if (dismissAllImplementation) {
			this.serviceImplementation._dismissAll = dismissAllImplementation;
		}
		if (createImplementation) {
			this.serviceImplementation._create = createImplementation;
		}
	}
}

export default UIDialogService;
